import * as mainActionTypes from '../mainActionTypes';
import actions from '../actions';
import { debounce } from 'lodash';

export default businessNameGenerator => {
  return store => {
    const fetchNamesListDebounced = debounce(async (businessIdea, tags, industryID, industryValue) => {
      const ideas = await businessNameGenerator.getBusinessNames(businessIdea, tags, { industryText: industryValue });
      store.dispatch(actions.setIndustry(industryID, industryValue, false));
      store.dispatch(actions.setNamesList(ideas));
    }, 400);
    return next => async action => {
      const { type, payload } = action;
      switch (type) {
        case mainActionTypes.SEARCH_BUSINESS_NAMES:
          {
            const { businessIdea, tags, industry } = payload;
            fetchNamesListDebounced(businessIdea, tags, industry);
          }
          break;

        case mainActionTypes.SEARCH_BUSINESS_NAMES_AND_INDUSTRY:
          {
            const { businessIdea, tags, industryID, industryValue } = payload;
            store.dispatch(actions.setBusinessIdea(businessIdea));
            fetchNamesListDebounced(businessIdea, tags, industryID, industryValue);
          }
          break;

        case mainActionTypes.SORT_NAMES:
          {
            const selectedName = store.getState().namesList[store.getState().selectedName.selectedIndex];
            next(action);
            const newIndex = store.getState().namesList.findIndex(name => name === selectedName);
            store.dispatch(actions.setSelectedName(newIndex));
          }
          break;

        case mainActionTypes.FIND_DOMAIN:
          {
            const { nameAfterEdit, indexEdited } = payload;
            const domain = await businessNameGenerator.getAvailableDomainNameFromBusinessName(nameAfterEdit);
            const index = indexEdited;
            store.dispatch({
              type: mainActionTypes.SET_DOMAIN_NAME,
              payload: { index, domain }
            });
          }
          break;
        default:
          next(action);
          break;
      }
      try {
      } catch (error) {
        console.error(error);
      }
    };
  };
};
